import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { auth, qk } from "../../api/admin";
import { setCsrfToken } from "../../api/client";
import { deviceInfo, safeReturnTo } from "../../auth/device";
import { classifySignInError } from "../../auth/signInErrors";
import { Loading } from "../../components/ui";
import { isAppPath } from "../../lib/modeSwitch";
import { useNavigate } from "../../lib/navigate";

export const Route = createFileRoute("/auth/callback")({
  staticData: { crumb: { label: "Signing in", parents: [] } },
  component: Callback,
});

function Callback() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    (async () => {
      try {
        const { completeMicrosoftSignIn } = await import("../../auth/msal");
        const result = await completeMicrosoftSignIn();
        if (!result) {
          await navigate({ to: "/signin", replace: true });
          return;
        }
        const session = await auth.microsoft(result.idToken, deviceInfo(), result.graphToken);
        setCsrfToken(session.csrf_token);
        qc.setQueryData(qk.me, session.me);
        const to = safeReturnTo(result.returnTo);
        // App mode is another app on this origin: load it.
        if (isAppPath(to)) window.location.replace(to);
        else await navigate({ to, replace: true });
      } catch (e) {
        await navigate({
          to: "/signin",
          search: { error: classifySignInError(e) === "cancelled" ? undefined : classifySignInError(e) },
          replace: true,
        });
      }
    })();
  }, [navigate, qc]);

  return (
    <main className="flex h-full items-center justify-center">
      <Loading label="Signing you in" />
    </main>
  );
}
